import { Account, Amount, Entry, Transaction } from "../domain";
import { assertType, uuid } from "../base";

class BalanceSheet {
    private _entries: Entry[];

    constructor(entries:Entry[]) {
        assertType(entries, "entries", Array, Entry);
        this._entries = entries;
    }

    get entries() { return this._entries; }

    static from(transactions: Transaction[]) {

        function addToAccount(account:Account, amount:Amount, entries:Record<string, Entry>) {
            const accUuid = account.uuid;
            const existingEntry = (accUuid in entries) ? entries[accUuid] : new Entry(uuid(), account.getRef(), Amount.identity());
            
            entries[accUuid] = new Entry(uuid(), account.getRef(), existingEntry.amount.add(amount));

            if (account.parent) {
                addToAccount(account.parent.obj(), amount, entries);
            }
        }

        const keyEntries:Record<string, Entry>={};

        transactions.forEach(transaction => {
            transaction.entries.forEach(entry => {
                addToAccount(entry.account.obj(), entry.amount, keyEntries);
            });
        });

        const entries = Object.entries(keyEntries)
            .map(entry => entry[1]);

        return new BalanceSheet(entries);
    }
}

export {BalanceSheet}
